/**
 * @Author: Ali2vu <751815097@qq.com>
 * @Date: 2020-04-21 11:38:05
 * @LastEditors: Ali2vu
 * @LastEditTime: 2020-04-30 16:37:17
 */

import * as request from '@/utils/request'

export default {
  /**
   * getWsAccountList
   * @description 查看子账号
   * @author YQ
   * @date 2019-01-19
   * @param {*} data
   * @returns
   */
  getWsAccountList(data) {
    return request.post('/ws/accountList', data)
  },
}